<div class="ev-statistics">
    <div class="statistics-header">
        <div class="header-content">
            <h1>Statistikk</h1>
            @if (this.mapStateService.mapModeSignal() === mapMode.Market2) {
            <div class="sub-title">Marked</div>
            }
            @if (this.mapStateService.mapModeSignal() === mapMode.Properties) {
            <div class="sub-title">Eiendom</div>
            }
            @if (this.mapStateService.mapModeSignal() === mapMode.NewDwellings) {
            <div class="sub-title">Nybygg</div>
            }
            <div class="statistics-close" (click)="onCloseStatistics()"></div>
        </div>

        <div>
            @if (this.mapStateService.mapModeSignal() === mapMode.Market2) {
            <div class="price-statistics-report-button-wrapper show">
                <div class="open-report-wizard-button" (click)="openReportWizardDialog()">Lag rapport</div>
            </div>
            }

        </div>
    </div>
    <div class="statistics-wrapper has-report-button">
        @if (currentPane === StatisticPanes.none) {
        <div class="navigation-wrapper" [ngClass]="{ 'content-active': false }">
            <div class="button" (click)="showStatisticsPane(StatisticPanes.price)">Prisstatistikk</div>

                @if (hasMarketSharesRole() && this.mapStateService.mapModeSignal() === mapMode.Market2) {
                    <div class="button" (click)="showStatisticsPane(StatisticPanes.marketShares)">Markedsandeler megler</div>
                }
                @if (hasDemographicsRole()) {
                    <div class="button" (click)="showStatisticsPane(StatisticPanes.demographyInhabitants)">Demografi: Innbyggere</div>
                }
                @if (hasDemographicsRole() && this.mapStateService.mapModeSignal() !== mapMode.NewDwellings) {
                    <div class="button" (click)="showStatisticsPane(StatisticPanes.demographyBuyers)">Demografi: Kjøpere</div>
                }
                @if (hasSubscriptionReportRole() && this.mapStateService.mapModeSignal() === mapMode.Market2) {
                    <div class="button dark subscribe" (click)="showStatisticsPane(StatisticPanes.subscriptionReport)">
                        <div class="subscribe-icon"></div>
                        Ukesrapport
                    </div>
                }
            </div>
        }
        @if (currentPane !== StatisticPanes.none) {
            <div class="content-wrapper">
                @if (currentPane === StatisticPanes.price) {
                    <div class="container">
                        <div class="header-wrapper" (click)="showStatisticsPane(StatisticPanes.none)">
                            <div class="header">Prisstatistikk</div>
                            <div class="close"></div>
                        </div>
                        <div class="content">
                            <price-statistics [statistics]="statistics()"></price-statistics>
                        </div>
                    </div>
                }
                @if (hasMarketSharesRole()) {
                    @if (currentPane === StatisticPanes.marketShares) {
                        <div class="container">
                            <div class="header-wrapper" (click)="showStatisticsPane(StatisticPanes.none)">
                                <div class="header">Markedsandeler megler</div>
                                <div class="close"></div>
                            </div>
                            <div class="content">
                                <estate-agent-market-shares [estateAgentMarketShares]="estateAgentMarketShares()"></estate-agent-market-shares>
                            </div>
                        </div>
                    }
                }
                @if (hasDemographicsRole()) {
                    @if (currentPane === StatisticPanes.demographyInhabitants) {
                        <div class="container">
                            <div class="header-wrapper" (click)="showStatisticsPane(StatisticPanes.none)">
                                <div class="header">Demografi: Innbyggere</div>
                                <div class="close"></div>
                            </div>
                            <div class="content">
                                <inhabitant-demography></inhabitant-demography>
                            </div>
                        </div>
                    } @else if (currentPane === StatisticPanes.demographyBuyers) {
                        <div class="container">
                            <div class="header-wrapper" (click)="showStatisticsPane(StatisticPanes.none)">
                                <div class="header">Demografi: Kjøpere</div>
                                <div class="close"></div>
                            </div>
                            <div class="content">
                                <buyer-demography></buyer-demography>
                            </div>
                        </div>
                    }
                }
                @if (hasSubscriptionReportRole()) {
                    @if (currentPane === StatisticPanes.subscriptionReport) {
                        <div class="container">
                            <div class="header-wrapper dark" (click)="showStatisticsPane(StatisticPanes.none)">
                                <div class="header">Ukesrapport</div>
                                <div class="close"></div>
                            </div>
                            <div class="content">
                                <subscription-report></subscription-report>
                            </div>
                        </div>
                    }
                }
            </div>
        }
    </div>
</div>

@if (hasMarketSharesRole && this.mapStateService.mapModeSignal() === mapMode.Market2) {
<report-wizard [showDialog]="showPriceStatisticsReportWizard" [showLoader]="loadingDataForPriceStatisticsReport"
    [statistics]="statistics()" (onClose)="closeStatisticsReport()"
    (onConfirm)="generatePriceStatisticsReportV2($event)"></report-wizard>
}